import {useMutation} from "@tanstack/react-query";
import type {AxiosError} from "axios";

import {errorHandler} from "@/src/modules/core/lib";

import {isShiftGateBusinessError} from "../lib/shift-gate-errors";
import {officerService} from "../services";
import {ShiftEndRequest} from "../types";

export function useShiftEnd() {
  return useMutation({
    mutationFn: (data: ShiftEndRequest) => officerService.shiftEnd(data),
    onError: (error) => {
      if (isShiftGateBusinessError(error)) return;
      errorHandler(error as AxiosError);
    },
  });
}
